import { ApiService } from '../../app-lite/api/api.service';
import { CodeTypeModel } from '../../app-lite/core/models/code-type';

import CountriesStatesHtml from './countries.countries-states.html';

export function CountriesStates (
  $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller : 'CountriesStatesCtrl',
    name       : 'app.countries',
    templateUrl: CountriesStatesHtml,
    url        : '/countries',
    resolve    : {
      countries: ( workshopAPI : ApiService ) : ng.IPromise<Array<CodeTypeModel>> => workshopAPI.get('/system/country_types')
    }
  });
}